import Controller from '@ember/controller';
import { beebeeAjaxGet } from 'beebee-base/lib/utility';
import moment from 'moment-timezone';

import { action, computed, set } from '@ember/object';

import { task, timeout } from 'ember-concurrency';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';

import getConfig from 'beebee-base/lib/get-config';
export default class SciclubController extends Controller {
  @iService notify;
  queryParams = ['contact_id', 'project_id'];
  @iService router;
  @iService intl;
  @iService session;
  @iService store;
  @iController('application') applicationController;

  @computed('from_date')
  get annoCorrente() {
    if (!this.from_date) {
      return '';
    }

    return `${moment(this.from_date).format('YYYY')} - ${moment(this.from_date).add(1, 'years').format('YYYY')}`;
  }

  @(task(function* () {
    yield timeout(250);

    if (!this.session.token) {
      return;
    }

    if (!this.session.option_field) {
      // Bounded retry: option_field loads async; wait for it with backoff
      // instead of unconditional self-recursion (which spins forever if it
      // never loads). Cap at 20 attempts (~10s total) then bail.
      const maxRetries = 20;
      let attempt = 0;
      while (!this.session.option_field && attempt < maxRetries) {
        attempt++;
        yield timeout(500);
        if (!this.session.token) {
          return;
        }
      }
      if (!this.session.option_field) {
        return;
      }
    }

    if (!this.from_date || !this.to_date) {
      set(
        this,
        'from_date',
        moment(this.session.option_field?.segreteria_from_date, 'DD/MM/YYYY').format(
          'YYYY-MM-DDTHH:mm:ssZ'
        )
      );
      set(
        this,
        'to_date',
        moment(this.session.option_field?.segreteria_to_date, 'DD/MM/YYYY').format(
          'YYYY-MM-DDTHH:mm:ssZ'
        )
      );
    }

    const customData = yield beebeeAjaxGet(
      `${getConfig(this).APP.urlApi}/sciclub_personal_area`,
      this.session.token,
      {
        from_date: this.from_date,
        to_date: this.to_date,
      }
    );

    const dataApi = customData?.data?.[0];
    set(this, 'customData', dataApi);

    if (this.detailAtleta?.atleta_id && dataApi) {
      const atleta = dataApi.atleti.find((i) => i.atleta_id === this.detailAtleta?.atleta_id);
      if (atleta) {
        set(this, 'detailAtleta', atleta);
      }
    }
  }).restartable())
  loadDataTask;

  @(task(function* (contact_id) {
    yield timeout(100);

    const c = yield this.store.findRecord('contact', contact_id, {
      reload: true,
    });

    set(this, 'editContact', c);
  }).restartable())
  editDataTask;

  @(task(function* (contact) {
    const requiredFields = ['first_name', 'last_name', 'cod_fiscale'];

    if (contact.id && parseInt(contact.id) === this.customData?.contatto?.contact_id) {
      requiredFields.push('mail', 'mobile');
    } else {
      requiredFields.push('luogo_nascita', 'data_nascita');
    }

    const contatto = contact || {};
    const address = contatto.get('addresses')?.[0];

    const saveErrors = {};

    // Controllo campi base
    requiredFields.forEach((field) => {
      const value = contatto.get(field);
      if (!value || value.trim() === '') {
        saveErrors[field] = field;
      }
    });

    // Controllo campi dell'indirizzo, se richiesti
    if (contact.id && parseInt(contact.id) === this.customData?.contatto?.contact_id) {
      const addressFields = [
        'location_address_street',
        'location_address_postal_code',
        'location_address_house',
        'location_address_country',
        'location_address_city',
      ];

      if (!address) {
        saveErrors.address = true;
      } else {
        addressFields.forEach((field) => {
          const value = address.get(field);
          if (!value || value.trim() === '') {
            saveErrors.address = true;
          }
        });
      }
    }

    set(contact, 'saveErrors', null);
    if (Object.keys(saveErrors).length > 0) {
      set(contact, 'saveErrors', saveErrors);
      this.notify.warning('Completa i dati anagrafici');
      return false;
    }

    yield this.applicationController.saveRecordRelated(contact);
    yield this.loadDataTask.perform();

    set(this, 'editContact', null);
  }).restartable())
  saveContactTask;

  @action
  showAtleta(atleta) {
    set(this, 'detailAtleta', atleta);
    set(this, 'showTab', 'atleti');
    set(this, 'showMenu', null);
  }

  @action
  moveNextYear() {
    set(this, 'from_date', moment(this.from_date).add(1, 'years').format('YYYY-MM-DDTHH:mm:ssZ'));
    set(this, 'to_date', moment(this.to_date).add(1, 'years').format('YYYY-MM-DDTHH:mm:ssZ'));
    this.loadDataTask.perform();
  }

  @action
  movePrevYear() {
    set(
      this,
      'from_date',
      moment(this.from_date).subtract(1, 'years').format('YYYY-MM-DDTHH:mm:ssZ')
    );
    set(this, 'to_date', moment(this.to_date).subtract(1, 'years').format('YYYY-MM-DDTHH:mm:ssZ'));
    this.loadDataTask.perform();
  }

  @(task(function* () {
    yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/../logout?access_token=${this.session.token}`);

    if (this.socket) {
      this.socket.emit('logout', {
        user: this.content?.me?.id,
        token: this.session.token,
      });
    }

    this.session.logout();
    this.store.unloadAll();

    this.router.transitionTo('index');
    yield timeout(100);
    window.location.reload(true);
  }).drop())
  logoutTask;

  @(task(function* (payment) {
    const requiredFields = [
      'first_name',
      'last_name',
      'mail',
      'mobile',
      'cod_fiscale',
      'location_address_street',
      'location_address_postal_code',
      'location_address_house',
      'location_address_country',
      'location_address_city',
    ];

    const contatto = this.customData?.contatto || {};
    const isEmptyOrNull = (field) => !contatto[field] || contatto[field].trim() === '';

    const incompleteFields = requiredFields.filter((field) => isEmptyOrNull(field));

    if (incompleteFields.length > 0) {
      set(this, 'showTab', 'profilo');
      this.notify.warning(
        'Completa i tuoi dati anagrafici prima di procedere col pagmamento'
      );
      return false;
    }

    if (!payment?.payment_id) return;

    const payStore = yield this.store.findRecord('payment', payment.payment_id, {
      reload: true,
    });

    if (!payStore) {
      return;
    }

    set(this, 'payNowData', {
      payment: payStore,
      contact_id: this.session.me.get('id'),
      request_by: 45322,
    });
  }).restartable())
  payNowTask;

  @action
  setTab(tab = null) {
    // Guard against the DOM event leaking in when used as a bare {{on "click"}} handler
    if (tab instanceof Event) {
      tab = null;
    }
    set(this, 'showTab', tab);
    set(this, 'showMenu', null);
  }
}
